import { EmojiApi } from "@app/shared/sdk";

/** An questionaire database that the data source uses to retrieve data for the table. */
export class ExtraEmojisDatabase {
  constructor(private _emojiApi: EmojiApi) {}

  getData(page?): Promise<any> {
    if (!page.pageSize) {
      page.pageSize = 48;
    }
    return new Promise((resolve, reject) => {
      let filter = {
        limit: page.pageSize,
        skip: page.pageIndex * page.pageSize,
        order: ["order ASC"],
        where: { isActive: true },
      };
      this._emojiApi.find(filter).subscribe(
        (emojis: any[]) => {
          resolve(emojis);
        },
        () => {
          // Show the success message
          alert("Internal Server Error!");
          reject();
        }
      );
    });
  }
}
